import { render } from "./StockOverview.vue?vue&type=template&id=a676816e"
import script from "./StockOverview.vue?vue&type=script&lang=js"
export * from "./StockOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__